module.exports = __webpack_public_path__ + "static/media/bpmeasurex-3.fe8656f1.jpg";